import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import PageLayout from "../UI/PageLayout";
import MarketingBreakdownPlatformDropdowns from "./MarketingReportingPlatformPageDropdowns";
import ContentForPage from "../../containers/ContentForPage";
import CustomCategoryDropdowns from "../UI/CustomCategoryDropdowns";

const MarketingReportingPlatformPage = () => {
  const { platform } = useParams();

  // Update Facebook platform name to Meta
  const platformName = platform === "facebook" ? "meta" : platform;

  return (
    <PageLayout
      title={"Marketing Reporting"}
      subTitle={
        String(platformName).charAt(0).toUpperCase() +
        String(platformName).slice(1)
      }
      dropdowns={<><MarketingBreakdownPlatformDropdowns platform={platform} /><CustomCategoryDropdowns /></>}
      content={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
          }}
        >
          <ContentForPage
            extraApiArgs={{
              platform: platform,
            }}
            pageName={"marketing_reporting_channel"}
            gridLayout={[
              { span: 12 },
              { span: 12 },
              { span: 12 },
              { span: 12 },
            ]}
          />
        </div>
      }
    />
  );
};

export default MarketingReportingPlatformPage;
